//ecd:-817567213H20261022084009_V3.0
import { request, requestOrNull, seg, Page } from './apiSupport';
import { CategoryDTO } from './CategoryDTO';
import { CategoryKeyDTO } from './CategoryKeyDTO';
import { CategorySrchDTO } from './CategorySrchDTO';

/**
 * REST client for Category.
 *
 * Calls the endpoints CategoryController exposes. Generated from the same model the
 * server is, so a change to the DSL shows up here as a type error rather than
 * at runtime.
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
const BASE = '/api/petstore/category';

/** Registers a new Category. */
export async function create(input: CategoryDTO): Promise<CategoryDTO> {
    return request<CategoryDTO>('POST', BASE, input);
}

/** The Category with this identifier, or null when there is none. */
export async function findById(categoryId: number): Promise<CategoryDTO | null> {
    return requestOrNull<CategoryDTO>('GET', BASE + '/' + seg(categoryId));
}

/** Every Category matching the condition. */
export async function search(condition: CategorySrchDTO): Promise<Page<CategoryDTO>> {
    return request<Page<CategoryDTO>>('POST', BASE + '/search', condition);
}

/** Updates an existing Category. */
export async function update(input: CategoryDTO): Promise<CategoryDTO> {
    return request<CategoryDTO>('PUT', BASE, input);
}

/** Updates several in one transaction; none are applied if any fails. */
export async function batchUpdate(inputs: CategoryDTO[]): Promise<void> {
    return request<void>('PUT', BASE + '/batch', inputs);
}

/** Deletes each key, answering for each whether it was there. */
export async function deleteMany(keys: CategoryKeyDTO[]): Promise<boolean[]> {
    return request<boolean[]>('POST', BASE + '/delete', keys);
}

/** Deletes the Category with this identifier. */
export async function deleteById(categoryId: number): Promise<boolean> {
    return request<boolean>('DELETE', BASE + '/' + seg(categoryId));
}

